import { Action } from "redux";
import { Language, Price, ThunkAction } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { showAlert } from "./Alerts.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["GET_PRICES_START", "GET_PRICES_SUCCESS"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type GetPricesStart = ActionBase<"GET_PRICES_START"> & { languageId: Language };
type GetPricesSuccess = ActionBase<"GET_PRICES_SUCCESS"> & {
  prices: Price[];
  languageId: Language;
};

export type PricesAction = GetPricesStart | GetPricesSuccess;

export const isPricesAction = (action: Action): action is PricesAction =>
  isActionType(action, ActionTypeKeys);

export const getPrices =
  (siteId: string, languageId: Language): ThunkAction<Promise<void>> =>
  (dispatch, getState) => {
    const loadState = getState().loadStates.prices;

    if (loadState !== "unloaded" && loadState !== undefined) {
      return Promise.resolve();
    }

    dispatch(getPricesStart(languageId));

    return fetch({ dispatch, languageId, authorize: false })
      .get<Price[]>(`sites/${siteId}/prices`)
      .then((res) => {
        dispatch(getPricesSuccess(res.data, languageId));
      })
      .catch((error) => {
        dispatch(
          showAlert("Beim Laden der Preis-Daten ist ein Fehler aufgetreten!"),
        );
        throw error;
      });
  };

const getPricesStart = (languageId: Language): GetPricesStart => ({
  type: "GET_PRICES_START",
  languageId,
});

const getPricesSuccess = (
  prices: Price[],
  languageId: Language,
): GetPricesSuccess => ({ type: "GET_PRICES_SUCCESS", prices, languageId });
